import { IdValue } from '../../../shared/models/id-value.model';

export enum PrepaidItemType {
  NotAssigned = 0,
  HazardInsurance = 1,
  MortgageInsurance = 2,
  Line1003 = 3,
  PropertyTaxes = 4,
  HOD = 5,
  FloodInsurance = 6,
  Line1007 = 7,
  OtherAmount = 100,
}

export const otherExpenseTypes: IdValue<number, number, string>[] = [
  new IdValue(0, PrepaidItemType.NotAssigned, 'Select'),
  new IdValue(3, PrepaidItemType.Line1003, 'Supplemental Expense (1)'),
  new IdValue(6, PrepaidItemType.FloodInsurance, 'Flood Insurance'),
  new IdValue(7, PrepaidItemType.Line1007, 'Supplemental Expense (2)'),
  new IdValue(100, PrepaidItemType.OtherAmount, 'Other Amount'),
];

export const subFiTypes: IdValue<number, number, string>[] = [new IdValue(0, 0, 'Not HELOC'), new IdValue(1, 1, 'HELOC')];

export enum PropertyTaxCalculation {
  Calculated = 'Calculated',
  FixedDollarAmount = 'Fixed Dollar Amount',
}
